// extracted by mini-css-extract-plugin
module.exports = {"permissionDenied":"permissionDenied__permissionDenied___3YkiI"};